var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import "./property-styles.scss";
import { t } from '@mp/locale';
import { unitSizeLabels, } from "../../services/schedulerService";
export default function PropertyExtra(_a) {
    var totalSpaces = _a.totalSpaces, spacesSize = _a.spacesSize, sizeUnit = _a.sizeUnit;
    return (_jsxs("div", __assign({ "data-qa": "multiple-spaces-area", className: "total-area" }, { children: [_jsxs("span", __assign({ "data-qa": "multiple-spaces-area-title", className: "font-bold" }, { children: [" ", t("CAPTURE_SERVICES.ORDER.SPACES.LIST.extraSpacesTotal"), " "] })), _jsxs("div", __assign({ "data-qa": "multiple-spaces-area-size", className: "total-area__size" }, { children: [_jsxs("span", __assign({ className: "font-bold" }, { children: [" ", totalSpaces, " "] })), " ", t("CAPTURE_SERVICES.ORDER.SPACES.LIST.extraSpacesSummary"), " ", _jsxs("strong", { children: [Math.ceil(+spacesSize).toLocaleString(), " ", unitSizeLabels[sizeUnit]] })] }))] })));
}
